import { Component, OnInit, ViewChild, Input, Output, EventEmitter, AfterViewChecked, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import SignaturePad from 'signature_pad';
import { Options, ImageResult } from "ngx-image2dataurl";
import { ErrorDiagnosticService } from 'src/app/_services/error-diagnostic.service';

@Component({
  standalone: false,
  selector: 'app-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.scss']
})
export class SignaturePadComponent implements OnInit, AfterViewChecked {
  activeTab: string = 'sign';
  setActiveTab(tab: string) {
    this.activeTab = tab;
    this.getSubtypeAndClear(tab);
  }
  @ViewChild('sPad') signaturePadElement;
  signaturePad: any;
  @ViewChild('fileUpload') fileUpload;
  @Input() currentSign: string;
  @Input() currentSignSubtype: string = 'sign';
  @Input() modal: any;
  @Input() withUpload: boolean = false;
  @Input() driverView: boolean = false;
  @Output() sendSign = new EventEmitter<object>();
  allowedExtensionsConfig: Array<any> = [
    { longName: "image/jpg", name: "jpg" },
    { longName: "image/jpeg", name: "jpeg" },
    { longName: "image/png", name: "png" },
  ];
  allowedExtensionsText: string = this.allowedExtensionsConfig.map(x => x.name).join(', ');
  acceptedExtensionsText: string = this.allowedExtensionsConfig.map(x => x.longName).join(', ');
  options: Options = {
    resize: {
      maxHeight: 170,
      maxWidth: 340
    },
    // allowedExtensions: ['jpg', 'png', 'jpeg']
    allowedExtensions: this.allowedExtensionsConfig.map(x => x.name)
  };

  constructor(
    private toastr: ToastrService,
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef,
    private errorDiagnosticService: ErrorDiagnosticService
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.signaturePad = new SignaturePad(this.signaturePadElement.nativeElement);
  }

  clear() {
    this.clearUpload();
    this.signaturePad.clear();
  }

  undo() {
    this.clearUpload();
    const data = this.signaturePad.toData();
    if (data) {
      data.pop(); // remove the last dot or line
      this.signaturePad.fromData(data);
    }
  }

  clearUpload() {
    if (!!this.filePath) {
      this.filePath = null;
      this.fileImg = null;
      this.fileUpload.nativeElement.value = "";
    }
  }

  download(dataURL, filename) {
    const blob = this.dataURLToBlob(dataURL);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;

    document.body.appendChild(a);
    // a.click();
    window.URL.revokeObjectURL(url);
  }

  dataURLToBlob(dataURL) {
    const parts = dataURL.split(';base64,');
    const contentType = parts[0].split(':')[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);
    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }

    this.sendSign.emit({ type: this.currentSign, subType: this.currentSignSubtype, sign: dataURL, contentType: contentType });

    return new Blob([uInt8Array], { type: contentType });
  }

  savePNG() {
    if (this.signaturePad.isEmpty() && !!!this.filePath) {
      alert('Please provide a signature first.');
    } else {
      if (this.filePath) {
        this.download(this.filePath, 'signature.png');
      } else {
        const dataURL = this.signaturePad.toDataURL(); // 'image/svg+xml' --> for parsing to svg
        this.download(dataURL, 'signature.png');
      }
      this.modal.close();
    }
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.cdr.detectChanges();
  }

  fileImg = null;
  filePath = null;
  previewNg(e) {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => this.filePath = reader.result;
      reader.readAsDataURL(file);
    } else {
      this.toastr.error(this.translateService.instant('doc.signature_pad.extension_not_allowed_err'))
    }
    /* if (e.error != undefined) {
      this.toastr.error(this.translateService.instant('doc.signature_pad.extension_not_allowed_err'))
    }
    else {
      this.filePath = e.resized.dataURL;
    } */
  }

  preview(e) {
    const file = (e.target as HTMLInputElement).files[0];
    var mimeType = file.type;
    if (mimeType.match(/images\/*/) == null) {
      this.toastr.error(this.translateService.instant('doc.signature_pad.upload_type_err'));
      return;
    }
    this.fileImg = file;
    const reader = new FileReader();
    reader.onload = (e) => {
      this.filePath = reader.result as string;
    }
    reader.readAsDataURL(file);
  }

  checkEnabledSave() {
    return !(this.signaturePad && this.signaturePad.isEmpty()) ||
      !!this.filePath
  }

  getSubtypeAndClear(value) {
    this.currentSignSubtype = value;
    this.clear();
  }
}
